import {
  EditorBubbleMenu,
  EditorFormatBold,
  EditorFormatItalic,
  EditorFormatStrike,
  EditorFormatUnderline,
  EditorNodeBulletList,
  EditorNodeHeading1,
  EditorNodeHeading2,
  EditorNodeOrderedList,
  EditorNodeQuote,
  EditorNodeText,
  EditorProvider,
  EditorSelector,
  isSameMarkdown,
} from "@repo/ui/components/editor";
import type { ReactNode } from "react";
import { useFieldContext } from "@/shared/forms/form-context";

export interface RichTextFieldProps {
  placeholder?: string;
  className?: string;
  children?: ReactNode;
}

export function RichTextField({ placeholder = "Add description...", className, children }: RichTextFieldProps) {
  const field = useFieldContext<string>();

  return (
    <EditorProvider
      content={field.state.value}
      onUpdate={({ editor }) => {
        const markdown = editor.getMarkdown();
        // The editor's normalization of the stored text is not an edit.
        if (isSameMarkdown(editor, markdown, field.state.value ?? "")) return;
        field.handleChange(markdown);
      }}
      onBlur={() => field.handleBlur()}
      placeholder={placeholder}
      className={className ?? "text-sm prose prose-sm max-w-none [&_.tiptap]:min-h-[80px] [&_.tiptap]:outline-none"}
    >
      {children ?? (
        <EditorBubbleMenu className="flex items-center gap-0.5 rounded-md border bg-background p-0.5 shadow-md">
          <EditorSelector title="Format">
            <EditorNodeText />
            <EditorNodeHeading1 />
            <EditorNodeHeading2 />
            <EditorNodeBulletList />
            <EditorNodeOrderedList />
            <EditorNodeQuote />
          </EditorSelector>
          <EditorFormatBold />
          <EditorFormatItalic />
          <EditorFormatUnderline />
          <EditorFormatStrike />
        </EditorBubbleMenu>
      )}
    </EditorProvider>
  );
}
